import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AuthUser } from '@app/account/account-api.model';
import { AuthService } from '@app/shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { OrgSettingsService } from '@app/orgs/services/org-settings.service';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { OrgSelectorExternalWarningService } from '@app/orgs/services/org-selector-external-warning.service';
import { Router } from '@angular/router';

@Component({
  selector: 'dgx-learner-home-budget',
  templateUrl: './learner-home-budget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LearnerHomeBudgetComponent implements OnInit {
  public learnInBalanceUrl: string;
  private authUser: AuthUser;

  public i18n = this.translateService.instant([
    'LearnerHome_LearningBudget',
    'LearnerHome_ViewYourBalance',
    'LearningSearch_GoToMarketplace',
    'OrgSettings_MarketplaceWarning_Default',
  ]);

  constructor(
    private authService: AuthService,
    private translateService: TranslateService,
    private orgSettingsService: OrgSettingsService,
    private orgSelectorExternalWarningService: OrgSelectorExternalWarningService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authUser = this.authService.authUser;
    const currentPath = window.location.href;
    // Replaces the empty srcpath with the current href.
    const learnInBalanceUrl =
      this.authUser?.defaultOrgInfo?.settings?.learnInBalanceUrl?.replace(
        /(\?|&)srcpath=.*?(&|$)/,
        `$1srcpath=${encodeURIComponent(currentPath)}$2`
      );
    this.learnInBalanceUrl = learnInBalanceUrl;
  }

  goToMarketplace() {
    return this.orgSettingsService
      .getSetting(
        this.authUser?.defaultOrgInfo?.organizationId,
        'MarketplaceWarning'
      )
      .pipe(
        take(1),
        switchMap(
          (setting) =>
            setting.enabled
              ? this.orgSelectorExternalWarningService.showMarketplaceWarning(
                  setting.value,
                  'Degreed'
                )
              : of({}) // warning is disabled so just continue navigation
        )
      )
      .subscribe(() =>
        this.router.navigate(['/learning/search'], {
          queryParams: { term: '', orgId: -2, isMarketplaceCat: true },
        })
      );
  }
}
